import { useQuery } from "@tanstack/react-query";
import { convexQuery } from "@convex-dev/react-query";
import { api } from "@/elements/components/utils/convex-api";
import Loader from "@/elements/components/shared/loader";
import React, { Fragment } from "react";
import ParentCancelLessonScreen from "@/elements/components/cancellation/parent-cancel-lesson";
import TutorCancelLessonScreen from "@/elements/components/cancellation/tutor-cancel-lesson";

function CancelLessonScreen() {
  const { data: currentUser, isSuccess: isCurrentUserSuccess } = useQuery(
    convexQuery(api.account.queries.getCurrentUser, {})
  );
  const persona = currentUser?.persona;

  if (!isCurrentUserSuccess) {
    return <Loader />;
  }

  return persona === "parent" ? (
    <ParentCancelLessonScreen />
  ) : persona === "tutor" ? (
    <TutorCancelLessonScreen />
  ) : (
    <Fragment />
  );
}

export default CancelLessonScreen;
